import { useQuery } from '@tanstack/react-query';

import type { APMAsset } from '@cognite/apm-client';

import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../../utils/queryKeys';

export const useRootAPMAssetList = ({ enabled }: { enabled: boolean }) => {
  const { assetService } = useFDMServices();

  return useQuery<APMAsset[]>({
    queryKey: [QueryKeys.ASSET, 'root list'],
    queryFn: async () => {
      return assetService.getRootAPMAssets();
    },
    meta: { error: { captureError: true } },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled,
  });
};
